import { gql } from '@apollo/client';

export const DELETE_RESOURCES = gql`
  mutation deleteResources($ids: [ID]!) {
    deleteResources(ids: $ids)
  }
`;
